import React, { useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Container,
  Label,
  FormGroup,
  InputGroup,
} from "reactstrap";

import Breadcrumbs from "../../../components/Common/Breadcrumb";
import CalendarMultiMonth from "../../../components/Common/CalendarMultiMonth";

import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/l10n/pt.js";
import Flatpickr from "react-flatpickr";

const FormCalendar = () => {
  document.title = "Defender | Form Calendar";

  const [dateBasic, setDateBasic] = useState();
  const [dateTime, setDateTime] = useState();
  const [dateRange, setDateRange] = useState();
  const [dateMulti, setDateMulti] = useState();
  const [timeOnly, setTimeOnly] = useState();
  const [dateInline, setDateInline] = useState();
  const [monthOnly, setMonthOnly] = useState();
  const [dateMinMax, setDateMinMax] = useState();
  const [multiCalendarDates, setMultiCalendarDates] = useState([]);
  const [numberOfMonths, setNumberOfMonths] = useState(2);

  const disabledExampleDates = (() => {
    const base = new Date();
    const result = [];
    for (let monthOffset = 0; monthOffset <= 2; monthOffset++) {
      [1, 14, 18].forEach((day) => {
        const d = new Date(
          base.getFullYear(),
          base.getMonth() + monthOffset,
          day,
        );
        if (d >= new Date(base.getFullYear(), base.getMonth(), base.getDate())) {
          result.push(d);
        }
      });
    }
    return result;
  })();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Form Calendar" />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Date Picker</CardTitle>

                  <FormGroup className="mb-4">
                    <Label>Basic</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="dd-mm-aaaa"
                        value={dateBasic}
                        onChange={(d) => setDateBasic(d)}
                        options={{
                          locale: "pt",
                          altInput: true,
                          altFormat: "d-m-Y",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Data e Hora</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="dd-mm-aaaa hh:mm"
                        value={dateTime}
                        onChange={(d) => setDateTime(d)}
                        options={{
                          locale: "pt",
                          enableTime: true,
                          altInput: true,
                          altFormat: "d-m-Y H:i",
                          dateFormat: "Y-m-d H:i",
                          time_24hr: true,
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Intervalo (De – Até)</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="dd-mm-aaaa para dd-mm-aaaa"
                        value={dateRange}
                        onChange={(d) => setDateRange(d)}
                        options={{
                          locale: "pt",
                          mode: "range",
                          altInput: true,
                          altFormat: "d-m-Y",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-0">
                    <Label>Múltiplas datas</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="selecione várias"
                        value={dateMulti}
                        onChange={(d) => setDateMulti(d)}
                        options={{
                          locale: "pt",
                          mode: "multiple",
                          altInput: true,
                          altFormat: "d-m-Y",
                          dateFormat: "Y-m-d",
                        }}
                      />
                    </InputGroup>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-4">Variantes</CardTitle>

                  <FormGroup className="mb-4">
                    <Label>Apenas hora</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="hh:mm"
                        value={timeOnly}
                        onChange={(d) => setTimeOnly(d)}
                        options={{
                          locale: "pt",
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i",
                          time_24hr: true,
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Apenas mês</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="mm-aaaa"
                        value={monthOnly}
                        onChange={(d) => setMonthOnly(d)}
                        options={{
                          locale: "pt",
                          altInput: true,
                          altFormat: "F Y",
                          dateFormat: "Y-m",
                          plugins: [],
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-4">
                    <Label>Min/Max (próximos 30 dias)</Label>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="dd-mm-aaaa"
                        value={dateMinMax}
                        onChange={(d) => setDateMinMax(d)}
                        options={{
                          locale: "pt",
                          altInput: true,
                          altFormat: "d-m-Y",
                          dateFormat: "Y-m-d",
                          minDate: "today",
                          maxDate: new Date().fp_incr(30),
                        }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-0">
                    <Label>Inline</Label>
                    <Flatpickr
                      className="form-control d-block"
                      value={dateInline}
                      onChange={(d) => setDateInline(d)}
                      options={{
                        locale: "pt",
                        inline: true,
                        dateFormat: "Y-m-d",
                      }}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="h4 mb-1">
                    Calendar Multi Mês (custom)
                  </CardTitle>
                  <p className="card-title-desc">
                    Componente próprio, sem lib. Seleção de múltiplas datas
                    individuais (clique adiciona/remove). Parametrizável por
                    quantidade de meses lado a lado.
                  </p>

                  <FormGroup className="mb-3 d-flex align-items-center gap-3">
                    <Label className="mb-0">Quantidade de meses:</Label>
                    {[1, 2, 3].map((n) => (
                      <button
                        type="button"
                        key={n}
                        onClick={() => setNumberOfMonths(n)}
                        className={`btn btn-sm ${
                          numberOfMonths === n
                            ? "bg-primary-dark text-white"
                            : "btn-outline-secondary"
                        }`}
                      >
                        {n}
                      </button>
                    ))}
                  </FormGroup>

                  <CalendarMultiMonth
                    numberOfMonths={numberOfMonths}
                    selectedDates={multiCalendarDates}
                    onChange={setMultiCalendarDates}
                    disabledDates={disabledExampleDates}
                  />

                  <div className="mt-3">
                    <strong>Datas selecionadas: </strong>
                    {multiCalendarDates.length === 0 ? (
                      <em className="text-muted">nenhuma</em>
                    ) : (
                      multiCalendarDates
                        .slice()
                        .sort((a, b) => a - b)
                        .map((d) => d.toLocaleDateString("pt-BR"))
                        .join(", ")
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormCalendar;
